export enum TaxCategories {
  EQUITY = 'EQUITY',
  DEBT = 'DEBT',
  ELSS = 'ELSS',
  NON_EQUITY = 'NON_EQUITY',
  HYBRID_EQUITY = 'HYBRID_EQUITY',
  HYBRID_DEBT = 'HYBRID_DEBT',
  HYBRID_NON_EQUITY = 'HYBRID_NON_EQUITY',
  NON_EQUITY_OTHERS = 'NON_EQUITY_OTHERS',
  OTHERS = 'OTHERS'
}

export enum TransactionTypes {
  BUY = 'BUY',
  SELL = 'SELL',
  SIP = 'SIP'
}

export enum TransactionSource {
  POWER_UP = 'POWER_UP',
  EXTERNAL = 'EXTERNAL',
  INFINITE = 'INFINITE'
}

export type UnitAmount = {
  unit: 'RUPEES'
  amount: number
}

export type PercentageReturn = {
  unit: 'PERCENTAGE'
  value: number
}

export type FolioDetail = {
  folioNumber: string
  folioName: string
  folioLogo: string
  source: `${TransactionSource}`
  folioWealth: UnitAmount
}

export type MemberInvestmentEntryType = {
  userName?: string
  temporaryFamilyAccessToken?: string
  currentGain: UnitAmount
  investedAmount: UnitAmount
  investmentDetails?: {
    puInvestmentAmount: UnitAmount
    externalInvestmentAmount: UnitAmount
  }
  sipAmount?: UnitAmount
  fundReturns?: {
    fundAmount: UnitAmount
    returns: PercentageReturn
  }
  oneDayReturns?: {
    fundAmount: UnitAmount
    returns: PercentageReturn
  }
  xirr?: PercentageReturn | null
  lifeTimeXirr?: PercentageReturn | null
  averageNav?: UnitAmount
  balancedUnits?: number
  firstInvestmentTimeStamp?: number
  folioDetails?: FolioDetail[]
}

export type InvestmentDataType = {
  currentGain: UnitAmount
  investedAmount: UnitAmount
  investmentDetails: {
    puInvestmentAmount: UnitAmount
    externalInvestmentAmount: UnitAmount
  }
  sipAmount: UnitAmount
  fundReturns: {
    fundAmount: UnitAmount
    returns: PercentageReturn
  }
  oneDayReturns: {
    fundAmount: UnitAmount
    returns: PercentageReturn
  }
  xirr: PercentageReturn | null
  lifeTimeXirr?: PercentageReturn | null
  averageNav: UnitAmount
  balancedUnits: number
  firstInvestmentTimeStamp: number
  folioDetails: FolioDetail[]
  throughFamilyAccess: boolean
  secondaryUserName: string
  primaryUserName: string
  memberInvestmentData?: MemberInvestmentEntryType[]
}

export type InvestmentTransaction = {
  units: number
  nav: {
    unit: 'RUPEES'
    amount: number
  }
  txnAmount: {
    unit: 'RUPEES'
    amount: number
  }
  timestamp: number
  type: `${TransactionTypes}`
  source: `${TransactionSource}`
}

export type InvestmentTransactionList = {
  userTxnResponseList: InvestmentTransaction[]
  responseName: 'MUTUAL_FUND_L2'
  responseType: 'MUTUAL_FUND_L2'
  itemsCount: number
}

export type TaxInfo = {
  gains: number
  investedAmount: number
  taxRate: number
  taxableAmount: number
}

export type TaxLiabilityDataResponseType = {
  currentValue: number
  exitLoad: number
  stcgTaxInfo: TaxInfo
  ltcgTaxInfo: TaxInfo
  ltcgExemptionApplicable: boolean
  grandfatheringRuleApplicable: boolean
  fundType: string
  taxCategory: `${TaxCategories}`
}
